import { Injectable } from '@angular/core';

@Injectable()
export class UsersData {
  identificacion: string = '';
  nombre: string = '';
  apellido: string = '';
  email: string = '';
  edificiosAutorizados: string = '';
  marcasAutorizadas: string = '';
  tipoUsuario : string = '';
  subscripciónId:number=0;
  emailVerificado:string = ''
  celular:string = ''
}

export interface ResultObject<T> {
  success: boolean;
  message: string | null;
  result: T;
}
